import { render, staticRenderFns } from "./portafolioTextoComponent.vue?vue&type=template&id=5ebfe0b9&"
import script from "./portafolioTextoComponent.vue?vue&type=script&lang=js&"
export * from "./portafolioTextoComponent.vue?vue&type=script&lang=js&"
import style0 from "./portafolioTextoComponent.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports